import { jsx as _jsx } from "react/jsx-runtime";
import isString from "../../../common-utils/string/isString.util.js";
import isNumber from "../../../common-utils/number/isNumber.util.js";
import Fragment from "../../../components/atoms/Fragment/index.js";
const getKey = (item, key) => {
    if (item && typeof item === "object" && "id" in item)
        item.id;
    return key;
};
export const RenderListAtomComponent = ({ children, data, slots, slotProps, sx, itemAsKey, }) => {
    if (!data?.length)
        return null;
    const List = slots?.list ?? Fragment;
    const Item = slots?.item ?? Fragment;
    return (_jsx(List, { "data-testid": "RenderList", data: data, sx: sx, ...slotProps?.list, children: data.map((item, i) => (_jsx(Item, { "data-testid": "RenderListItem", data: item, index: i, ...slotProps?.item, children: children(item, i) }, itemAsKey && (isString(item) || isNumber(item)) ? item : getKey(item, i)))) }));
};
export default RenderListAtomComponent;
